import useApiService from 'services/api'
import { filterStoreRepo } from '../../../Filters/FilterStore'
import FilterModal, {
  FilterGroup,
  QuickFilterGroup,
} from '../../../Filters/components/FilterModal'
import { QuickShowHiddenFilter } from 'components/Filters/fields/QuickFilter'
import { RangeFilter } from '../../../Filters/fields/RangeFilter'
import { FilterIdentifier } from 'models/saved_view'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { HOSPITAL_COLUMNS } from '../hospitalColumnsInfo'
import { CommonFiltersetAccountGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetAccountGroup'
import { CommonFiltersetLocationGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetLocationGroup'

export function HospitalsFilterset({
  filterIdentifier,
  hideCampaignsFilter,
}: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const api = useApiService()
  const { data: campaignOptions } = api.useGetCampaignsOptions(
    'healthcare-hospitals',
    undefined,
    true
  )

  const hospitalsFilterStore = filterStoreRepo.getStore(filterIdentifier)

  const hospitalFilterHelper = createFilterColumnHelper({
    columns: HOSPITAL_COLUMNS,
  })

  return (
    <FilterModal identifier={filterIdentifier} store={hospitalsFilterStore}>
      <QuickFilterGroup>
        <QuickShowHiddenFilter filterStore={hospitalsFilterStore} />
      </QuickFilterGroup>
      <CommonFiltersetAccountGroup
        filterStore={hospitalsFilterStore}
        campaignOptions={campaignOptions}
        hideCampaignsFilter={hideCampaignsFilter}
      />
      <FilterGroup title="Hospital Insights">
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('total_hospital_days')}
          store={hospitalsFilterStore}
        />
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('total_hospital_beds')}
          store={hospitalsFilterStore}
        />
      </FilterGroup>
      <FilterGroup title="Dining Services">
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('meals_per_day')}
          store={hospitalsFilterStore}
        />
        {/* FIR-7418: integer dollar amounts — range filters, replacing the
            legacy Yes/No selects that never matched the stored values. */}
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('cafeteria')}
          store={hospitalsFilterStore}
        />
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('dietary')}
          store={hospitalsFilterStore}
        />
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('dietary_under_contract')}
          store={hospitalsFilterStore}
        />
      </FilterGroup>
      <CommonFiltersetLocationGroup
        filterStore={hospitalsFilterStore}
        stateSelectProps={hospitalFilterHelper.retrieveProps('state')}
        citySelectProps={hospitalFilterHelper.retrieveProps('city')}
      />
    </FilterModal>
  )
}
